// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
/*
*/
export const environment = {
  production: false,
  reportingBaseUrl: 'https://dcis.dev.ontariohealth.ca/reporting',
  jsonAdminURI: 'https://dcis.dev.ontariohealth.ca/json-admin',
  resourceProviderURI: 'https://dcis.dev.ontariohealth.ca/fe-8000',
  pcrEmpiURI: 'https://dcis.dev.ontariohealth.ca/pcr-empi',
  saveEntryURI: 'https://dcis.dev.ontariohealth.ca/save-entry-api/ServiceRequest/$save-entry',
  issuerURI: 'https://b2cdcisnonphi.b2clogin.com/tfp/99f9e401-d9e0-4dd0-9884-a57efbabc982/b2c_1_dcis_signin_dev_001/v2.0/',
  token_endpoint: 'https://b2cdcisnonphi.b2clogin.com/b2cdcisnonphi.onmicrosoft.com/b2c_1_dcis_signin_dev_001/oauth2/v2.0/token',
  logout_endpoint: 'https://b2cdcisnonphi.b2clogin.com/b2cdcisnonphi.onmicrosoft.com/b2c_1_dcis_signin_dev_001/oauth2/v2.0/logout',
  clientId: 'd968b023-c388-421e-ad33-ca73a60bc22f',
  redirectURI: 'https://dcis.dev.ontariohealth.ca/data-collection/',
  scopeUrl: 'https://b2cdcisnonphi.onmicrosoft.com/d968b023-c388-421e-ad33-ca73a60bc22f/openid https://b2cdcisnonphi.onmicrosoft.com/d968b023-c388-421e-ad33-ca73a60bc22f/offline_access',
  discoveryDocumentUrl: 'https://b2cdcisnonphi.b2clogin.com/tfp/b2cdcisnonphi.onmicrosoft.com/b2c_1_dcis_signin_dev_001/v2.0/.well-known/openid-configuration',
  azure_reset_password_URI: 'https://b2cdcisnonphi.b2clogin.com/b2cdcisnonphi.onmicrosoft.com/oauth2/v2.0/authorize?p=b2c_1_dcis_reset_password_dev_001',
  azure_resource_name: 'b2cdcisnonphi.b2clogin.com',
  azure_tenant_id: '99f9e401-d9e0-4dd0-9884-a57efbabc982',
  azure_policy_name: 'b2c_1_dcis_signin_dev_001',
  sessionInactiveSeconds: 1200,
  sessionTimeoutCountDownSeconds: 60, 
  sendEmailApiUri: 'https://dcis.dev.ontariohealth.ca/Notification/api/notification/SendEmail',
  sendEmailTo: 'eric.ma@ontariohealth.ca',
  storageAccountName: 'stnonphidcisdev001',
  storageContainerName: 'dcis-data-collection',
  goLiveDate: '2022-04-13',
  adminFileLocation: 'https://www.corhealthontario.ca/Documents-for-Support-Section/',
  procedureNumberLimit: 10,
  env: 'DEV'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
/*
The following section works when running the application on your local machine

export const environment = { 
  production: false,
  reportingBaseUrl: 'http://localhost:4200/reporting',
  jsonAdminURI: 'http://localhost:9000',
  resourceProviderURI: 'http://localhost:8000',
  pcrEmpiURI: 'http://localhost:8003',
  saveEntryURI: 'http://localhost:8006/ServiceRequest/$save-entry',
  issuerURI: 'http://localhost:9200',
  token_endpoint: 'http://localhost:9200/oauth/token',
  logout_endpoint: 'http://localhost:9200/oauth/logout',
  clientId: 'dcis',
  redirectURI: 'http://localhost:4200',
  scopeUrl: 'openid profile',
  discoveryDocumentUrl: 'http://localhost:9200/.well-known/openid-configuration',
  azure_reset_password_URI: 'https://dcissit.b2clogin.com/dcisdev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_DCIS_Reset_Password',
  sessionInactiveSeconds: 240, // 4 mins 
  sessionTimeoutCountDownSeconds: 60, // 1 min 
  sendEmailApiUri: 'https://app.ccn.on.ca/p9laKeWLSuZ4god0JQZySPA/api/Notification/SendEmail',
  sendEmailTo: 'kevin.dougan@smilecdr.com',
  storageAccountName: 'stnonphidcisdev001',
  storageContainerName: 'dcis-data-collection',
  goLiveDate: '2021-09-13',
  adminFileLocation: 'https://registryproject.corhealthontario.ca/Member/DownloadOneFile?sideBarType=Documents&fileName=',
  procedureNumberLimit: 10,
  env: 'DEV'
  };
*/
/*
The following section works when running the application on your local machine with B2C Authentication in DEV
export const environment = {
  production: false,
  reportingBaseUrl: 'http://localhost:4200/reporting',
  jsonAdminURI: 'http://localhost:9000',
  resourceProviderURI: 'http://localhost:8000',
  pcrEmpiURI: 'http://localhost:8003',
  saveEntryURI: 'https://dcis.dev.ontariohealth.ca/save-entry-api/ServiceRequest/$save-entry',
  issuerURI: 'https://b2cdcisnonphi.b2clogin.com/tfp/99f9e401-d9e0-4dd0-9884-a57efbabc982/b2c_1_dcis_signin_dev_001/v2.0/',
  token_endpoint: 'https://b2cdcisnonphi.b2clogin.com/b2cdcisnonphi.onmicrosoft.com/b2c_1_dcis_signin_dev_001/oauth2/v2.0/token',
  logout_endpoint: 'https://b2cdcisnonphi.b2clogin.com/b2cdcisnonphi.onmicrosoft.com/b2c_1_dcis_signin_dev_001/oauth2/v2.0/logout',
  clientId: 'd968b023-c388-421e-ad33-ca73a60bc22f',
  redirectURI: 'http://localhost:4200/',
  scopeUrl: 'https://b2cdcisnonphi.onmicrosoft.com/d968b023-c388-421e-ad33-ca73a60bc22f/openid',
  discoveryDocumentUrl: 'https://b2cdcisnonphi.b2clogin.com/tfp/b2cdcisnonphi.onmicrosoft.com/b2c_1_dcis_signin_dev_001/v2.0/.well-known/openid-configuration',
  azure_reset_password_URI: 'https://b2cdcisnonphi.b2clogin.com/b2cdcisnonphi.onmicrosoft.com/oauth2/v2.0/authorize?p=b2c_1_dcis_reset_password_dev_001',
  azure_resource_name: 'b2cdcisnonphi.b2clogin.com',
  azure_tenant_id: '99f9e401-d9e0-4dd0-9884-a57efbabc982',
  azure_policy_name: 'b2c_1_dcis_signin_dev_001',
  sessionInactiveSeconds: 1200,
  sessionTimeoutCountDownSeconds: 60, 
  sendEmailApiUri: 'https://dcis.dev.ontariohealth.ca/Notification/api/SendEmail',
  sendEmailTo: 'eric.ma@ontariohealth.ca',
  storageAccountName: 'stnonphidcisdev001',
  storageContainerName: 'dcis-data-collection',
  goLiveDate: '2022-04-13',
  adminFileLocation: 'https://registryproject.corhealthontario.ca/Member/DownloadOneFile?sideBarType=Documents&fileName=',
  procedureNumberLimit: 10,
  env: 'DEV'
};
*/
